import { useState, useEffect } from "react";
import { supabase } from "@/infra/supabase/client";

export const useOnboardingStatus = () => {
  const [isCompleted, setIsCompleted] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();

        if (!user) {
          setIsCompleted(null);
          setLoading(false);
          return;
        }

        const { data: profile } = await supabase
          .from("profiles")
          .select("onboarding_completed, is_admin")
          .eq("id", user.id)
          .single();

        // Admins não precisam fazer onboarding, considerar sempre como completo
        if (profile?.is_admin) {
          setIsCompleted(true);
        } else {
          setIsCompleted(profile?.onboarding_completed || false);
        }
      } catch (error) {
        console.error("Erro ao verificar status do onboarding:", error);
        setIsCompleted(false);
      } finally {
        setLoading(false);
      }
    };

    checkOnboardingStatus();
  }, []);

  return { isCompleted, loading };
};
